module.exports = {
          srcSet: __webpack_public_path__ + "3e8b153f.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "3e8b153f.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "3e8b153f.jpg",
          toString:function(){return __webpack_public_path__ + "3e8b153f.jpg"},
          
          width: 330,
          height: 200
        }